module.exports = __webpack_public_path__ + "static/media/codeTile.f2236dc2.jpg";